import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CareGuideNoteForm from '../containers/CareGuideNoteFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideNoteEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideNoteEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {

    return (
      <Translation>{(t) =>
        <div>
          <DocumentHead title={t('care_guide_note_route_edit')} />
          <CareGuideNoteForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideNoteEditScreen;

Logger.log('silly', `CareGuideNoteEditScreen loaded.`);